/**
 * A module of methods that you want to include in all actions.
 * This module is consumed by `createAction`.
 */
module.exports = {
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/reflux/src/ActionMethods.js
 ** module id = 203
 ** module chunks = 0
 **/